import { Text } from '../../utils/style/texts';
import { Flex } from '../Container/Flex';
// import { ColorPicker as MuiColorPicker } from 'material-ui-color';
// import MuiColorPicker from 'material-ui-color-picker'
// import {ChromePicker as MuiColorPicker } from 'react-colorful';
import { HexColorPicker } from 'react-colorful';

import React from 'react';
import { compose } from 'redux';
import styled from 'styled-components';
import { Popover } from '@mui/material';
import { isDark } from '../../utils/style/colors';

import './style.css';
import { Shadows } from '../../utils/style/shadows';
import TextField from '../Controls/TextField';

const ColorPicker = compose(

)(({ label, value, onChange, disabled }) => {
  if(!value) value = '';
  const [id] = React.useState(Date.now() + '');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [rawValue, setRawValue] = React.useState(value.replace('#', ''));
  React.useEffect(() => {
    setRawValue(value.replace('#', ''));
  }, [value, setRawValue]);
  React.useEffect(() => {
    if(anchorEl) setRawValue(value.replace('#', ''));
  }, [anchorEl, value]);

  const isOpen = Boolean(anchorEl);

  return (
    <Wrapper row align="center" disabled={disabled}>
      <Text>{label}</Text>
      <Flex row align="center">
        <Swatch
          color={value}
          onClick={e => setAnchorEl(e.currentTarget)}
          aria-describedby={id}
        />
      </Flex>
      <Popover
        id={id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        elevation={0}
        PaperProps={{ className: "colorPickerPaper" }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <HexColorPicker
          color={value}
          onChange={c => onChange(c)}
        />
        <TextField
          className={["input", isDark(value, .85) ? "dark" : "light"]}
          startAdornment="#"
          value={rawValue.toUpperCase()}
          onChange={c => {
            c = c.replace("#", '');
            if(/^[0-9A-F]*$/i.test(c) !== true) {
              return;
            }
            if(/^[0-9A-F]{6}$/i.test(c) === true) {
              onChange('#' + c);
            }
            setRawValue(c);
          }}
        />
      </Popover>
    </Wrapper>
  );

});

const Wrapper = styled(Flex)`
  ${props => props.disabled && `
    opacity: .5;
    pointer-events: none;
  `};
`;
const Swatch = styled.div`
  cursor: pointer;
  width: 25px;
  height: 25px;
  box-shadow: ${Shadows.small};
  transition: all .3s;
  background: ${props => props.color};
  margin-left: 10px;
  margin-right: 10px;
  &:hover {
    transform: scale(1.05);
  }
`;

export default ColorPicker;